<template>
    <div>

        <AreaComponents
            v-bind:curentEnvironment="curentEnvironment"
            v-bind:curentSolution="curentSolution"
            v-bind:typeSol="typeSol"
            v-bind:displayType="displayType"
            v-on:selectSolution="selectSolution"
            v-on:setDesktopSize="setDesktopSize"
            v-on:setShowPage="setShowPage"
        />

        <NavEnv
            v-bind:curentEnvironment="curentEnvironment"
            v-bind:activeEnv="activeEnv"

            v-bind:displayType="displayType"

            v-on:setActiveEnv="setActiveEnv"

            v-bind:typeSol="typeSol"
            v-bind:switchDisable="switchDisable"
            v-on:changeTypeSol="changeTypeSol"

            v-on:setShowPage="setShowPage"
        />

        <transition name="fade">
            <PageSection
                v-bind:showPage="showPage"
                v-bind:curentEnvironment="curentEnvironment"
                v-if="showPage"
                :key="showPage"
                v-on:closePage="closePage"
            />
        </transition>
        <!--<div class="hiden-preload-image">-->
            <!--<img-->
                <!--v-for="url  in envListImages" -->
                <!--:src="url" alt="">-->
        <!--</div>-->
    </div>
</template>

<script>
    import NavEnv from '@/components/NavEnv.vue'
    // import NavSections from '@/components/NavSections.vue'
    import AreaComponents from '@/components/AreaComponents.vue'
    import PageSection from "../components/PageSection.vue";


    export default {
        name: 'Environments',
        components: {
            // NavSections,
            AreaComponents, NavEnv, PageSection
        },
        props: ['selectEnvironments', 'activeEnv','envListImages'],
        data() {
            return {
                displayType: 'mob', //mob,tab,desk
                // activeEnvID: null,
                curentEnvironment: {},
                curentSolution: false,
                envpagedata: {},
                typeSol: false, // false = (Digital Workplace), true = (Smart Infrastructure)
                switchDisable: true, // false = (Digital Workplace), true = (Smart Infrastructure)
                showPage: false,
            }
        },
        watch: {
            'activeEnv'() {
                this.setDisableSwitcher(this.activeEnv);
            },
            'envpagedata'() {
            },
        },
        mounted() {

            if (this.activeEnv) {
                this.curentEnvironment = this.getEnvironmentFromID(this.activeEnv);
            } else {
                this.$emit('setActiveEnv', this.globalData.environments[0].id);
            }
            this.setDisableSwitcher(this.activeEnv);
        },
        methods: {
            setDisableSwitcher(id) {
                this.curentEnvironment = this.getEnvironmentFromID(id);
                this.curentSolution = false;
                if (this.curentEnvironment.image && this.curentEnvironment.image_smart) {
                    this.switchDisable = false;
                } else {
                    this.switchDisable = true;
                    if (this.curentEnvironment.image) {
                        this.typeSol = false;
                    } else {
                        this.typeSol = true;
                    }
                }
            },
            setActiveEnv(env_id) {
                this.$emit('setActiveEnv', env_id);
            },
            // switcherChange(){
            //     this.typeSol = !this.typeSol
            // },
            setEnvirement(id) {
                console.log(id)
                // this.$emit('setActiveEnv', this.curentEnvironment.id);
            },
            selectSolution(sol_id) {
                if (sol_id) {
                    this.curentSolution = this.globalData.solutions[sol_id];
                } else {
                    this.curentSolution = false
                }
            },
            changeTypeSol(type) {
                this.typeSol = type;
            },
            getEnvironmentFromID(id) {
                let elEnv = this.globalData.environments.find((el) => {
                    return el.id == id;
                });

                if (Object.prototype.hasOwnProperty.call(elEnv, "solutions")) {
                    elEnv.solutions = elEnv.solutions.map((item) => ({
                        ...item,
                        title: this.globalData.solutions[item.id].title
                    }))
                }

                return elEnv;
            },
            setShowPage(page) {
                this.showPage = page;
            },
            closePage() {
                this.showPage = '';
            },
            setDesktopSize(type) {
                this.displayType = type;
            }
        },
    }

</script>
<style>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */ {
        opacity: 0;
    }
</style>